export default __webpack_public_path__ + "static/media/botoes_genericos_01.2c18c240.mp3";